export default class PreView {
  constructor(data) {
    this.$box = false; // 图片容器加载状态
    this.isPreview = false; // 是否正在预览图片
    this.isShowUpload = true
    this.ts = null
    this.scale = 1
    this.maxScale = 5
    this.scalem = 1
    this.offsetImgX = 0
    this.offsetImgY = 0
    this.curOffsetX = 0
    this.curOffsetY = 0
    this.startX = 0
    this.startY = 0
    
    if (data) {
      this.isShowUpload = data.isShowUpload;
    }

    this.deleteContainer();
    this.createContainer();
    this.bind(); // 绑定事件
  }

  // 获取当前预览的照片
  getCurImage = () => this.$curImage

  // 删掉已有 container 避免创建多个
  deleteContainer() {
    const container = document.querySelector('#previewImage-container');
    if (container) {
      container.parentElement.removeChild(container);
    };
  }

  // 创建容器
  createContainer() {
    this.$container = document.createElement('div'); // 加载容器
    this.$container.id = 'previewImage-container'; // 容器加上id
    const $header = document.createElement('header');
    this.$backBtn = document.createElement('button');
    this.$backBtn.innerHTML = '<span class="iconfont icon-web-back">返回</span>';
    this.$backBtn.className = 'back-btn';
    $header.appendChild(this.$backBtn);
    if (this.isShowUpload) {
      this.$upload = document.createElement('div');
      this.$upload.innerHTML = '重新上传';
      this.$upload.className = 'right-menu upload';
      $header.appendChild(this.$upload);
    }
    this.$container.appendChild($header);
    document.body.appendChild(this.$container); // 插入容器到body
  }

  // 绑定事件
  bind() {
    if(!!document.querySelector('.lb-web')) {
      return;
    }
    $('body').on('click', '[data-preview]', this.start);
    $('body').on('click', '.attachment--preview .attachment-image', this.start);
    $('.attachment--preview .attachment-image').click(this.start);
    // 帮助文档页面 图片支持预览
    $('body').on('click', '.markdown-body .image', this.start);
    if (this.isShowUpload) {
      $('#previewImage-container').on('click', '.upload', this.upload);
      this.$upload.addEventListener('click', this.upload);
    }
    this.$container.addEventListener('click', this.handleMask);
    this.$backBtn.addEventListener('click', this.handleMask);
   
  }

  // 重新上传
  upload = (e) => {
    e.stopPropagation();
    document.querySelector('.image-uploader').click();
  }

  // 渲染图片
  renderImage(src) {
    if (this.$box === false) { // 加载图片容器
      const box = document.createElement('div');
      box.className += 'previewImage-box';
      this.$box = box; // 更新图片容器
    } else {
      this.$box.innerHTML = ''; // 已有图片容器-清空容器
    }
    const img = new Image();
    img.src = src;
    this.$box.appendChild(img);
    this.$container.appendChild(this.$box);
    this.$img = $('.previewImage-box img')
    this.wrapHeight = $('.previewImage-box').height()
    this.imgHeight = $('.previewImage-box img').height()
    this.imgWidth = $('.previewImage-box img').width()
    this.screenWidth = document.documentElement.clientWidth || 0
    this.$box.addEventListener('touchstart', this.handleStart);
    this.$box.addEventListener('touchmove', this.handleMove);
    this.$box.addEventListener('touchend', this.handleEnd);
  }

  // 打开预览
  start = (e) => {
    const curEle = e.target;
    this.$curImage = e.target;
    this.renderImage(curEle.src);
    this.$container.style.transform = 'translate(0)';
  }

  // 关闭预览
  close = () => {
    const container = this.$container
    this.$curImage = null;
    container.style.transform = 'translate(100%)';
  }

  // 点击遮罩，关闭预览
  handleMask = (e) => {
    e.stopPropagation();
    if (e.target === document.querySelector('.upload')) return;
    this.close();
  }
  handleStart = (e) => {
    e.preventDefault();
    this.ts = this.getTouches(e)
    if (e.targetTouches.length === 1) {
      const { x0, y0 } = this.getTouches(e)
      this.startX = x0
      this.startY = y0
      this.finger = false
    } else {
      this.finger = true
    }
  }
  // 禁止背景移动
  handleMove = (e) => {
    e.preventDefault();
    const touchTarget = e.targetTouches.length // 获得触控点数
    if (touchTarget === 1 && !this.finger) {
      this.move(e)
    }
    if (touchTarget > 1 && this.finger) {
      this.zoom(e)
    }
  }
  move(e) { 
    const { x0, y0 } = this.getTouches(e)
    const offsetX = this.startX - x0
    const offsetY = this.startY - y0
    this.offsetXM = -offsetX / this.scale
    this.offsetYM = -offsetY / this.scale
 
    this.curOffsetX = this.offsetXM + this.offsetImgX
    this.curOffsetY = this.offsetYM + this.offsetImgY
    this.imgAnimate({
      duration: 0,
      x: this.offsetXM + this.offsetImgX ,
      y: this.offsetYM + this.offsetImgY,
      scale: this.scale
    })
  }
  imgAnimate(config) { 
    this.$img.css({
      transform: `scale3d(${config.scale}, ${config.scale}, ${config.scale}) translate3d(${config.x}px, ${config.y}px, 0)`,
      transition: `transform ${config.duration}ms ease-out`
    })
  }
  zoom(e) {
    const tm = this.getTouches(e)
    this.scalem = this.getScale(this.ts, tm)
    let config = {
      duration: 0,
      x: this.offsetImgX  || 0,
      y: this.offsetImgY || 0,
      scale: this.scalem * this.scale
    }
   
    this.imgAnimate(config)
  }
  setThresholds() {
    const allow = this.getAllow()
    let config = {
      duration: 200,
      x: this.offsetImgX ,
      y: this.offsetImgY,
      scale: this.scale
    }
    if (this.offsetImgX > allow.x) {
      config['x'] = allow.x
      this.offsetImgX = allow.x
    }
    if (this.offsetImgX <= -allow.x) {
      config['x'] = -allow.x
      this.offsetImgX = -allow.x
    }
    if (this.offsetImgY >= allow.y0) {
      config['y'] = allow.y0
      this.offsetImgY = allow.y0
    }
    if (this.offsetImgY <= allow.y1) {
      config['y'] = allow.y1
      this.offsetImgY = allow.y1
    }
    this.imgAnimate(config)
  }

  handleEnd = (e) => {
    e.preventDefault();
    
    if (!this.finger) { 
      this.offsetImgX = this.curOffsetX
      this.offsetImgY = this.curOffsetY
      this.setThresholds()
    } else {
      const scale = this.scalem * this.scale
      this.scale = scale
      this.scalem = 1
      if (scale <= 1 || scale >= this.maxScale) {
        this.scalem = scale <= 1 ? 1 : this.maxScale
        this.scale = scale <= 1 ? 1 : this.maxScale
        let config = {
          duration: 200,
          x: this.offsetImgX,
          y: this.offsetImgY,
          scale: this.scalem
        }
        this.imgAnimate(config)
      }
    }
  }
  getTouches(e) {
    const touches = e.touches.length > 0 ? e.touches : e.changedTouches
    const { pageX: x0, pageY: y0 } = touches[0]
    const { pageX: x1 = 0, pageY: y1 = 0 } = touches[1] || {}
    return { x0, y0, x1, y1 }
  }
  getScale(ts, tm) {
    // 两手指的初始距离
    const fingerRangeS = Math.sqrt(
      Math.pow(Math.abs(ts.x1 - ts.x0), 2) +
        Math.pow(Math.abs(ts.y1 - ts.y0), 2)
    )
    // 两手指移动过程中的距离
    const fingerRangeM = Math.sqrt(
      Math.pow(Math.abs(tm.x1 - tm.x0), 2) +
        Math.pow(Math.abs(tm.y1 - tm.y0), 2)
    )
    const range = fingerRangeM / fingerRangeS
    return range
  }
  getAllow() {
    const scale = this.scale
    const allowX = Math.floor(
      (this.imgWidth * scale - this.screenWidth) / (2 * scale)
    )
    let allowY0, allowY1
    if (this.imgHeight * scale <= this.wrapHeight) {
      allowY0 = 0
      allowY1 = 0
    } else {
      allowY0 = Math.floor(
        (this.imgHeight * scale - this.wrapHeight) / (2 * scale)
      )
      allowY1 = -allowY0
    }
    return {
      x: allowX,
      y0: allowY0,
      y1: allowY1
    }
  }
  
}
